module.exports = "//d274d294w9cx2v.cloudfront.net/dfb2d01ec5754460259bd09b4f92eafe871ace85/images/payPalBadge.png";